// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Toolbar_toolbar__36k4K","title":"Toolbar_title__1NWsg","projColor":"Toolbar_projColor__3ldkV","projName":"Toolbar_projName__PXVEJ"};